import { Provider } from '@angular/core';

import { ProjectsService } from '@projects/services/projects.service';
import { PROJECTS_STORE } from '@projects/stores/projects.store';

export const PROJECTS_PROVIDERS: Provider[] = [ProjectsService, PROJECTS_STORE];
